import React from "react";
import SeoComponent from "../common/SeoComponent";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {fetchNews} from "../reducers/news";
import {t} from "../IntManager";
import NewsLayout from "./NewsLayout";

class NewsStocks extends SeoComponent {
    static fetchData(store, params) {
        return store.dispatch(fetchNews({page: params.page, groupID: 3}));
    }

    componentDidMount() {
        this.fetchNews();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.page !== prevProps.match.params.page) {
            this.fetchNews();
        }
    }

    fetchNews() {
        this.props.fetchNews({page: this.props.match.params.page, groupID: 3});
    }

    constructor(props, context) {
        super(props, context);

        this.renderHeader = this.renderHeader.bind(this);
        this.setComponentMetaTags = this.setComponentMetaTags.bind(this);
    }

    render() {
        return <NewsLayout news={this.props.news} activeIdx={2} match={this.props.match}
                           header={this.renderHeader()}
                           setComponentMetaTags={this.setComponentMetaTags()}
        />;
    }

    setComponentMetaTags() {
        this.setMetaTags(t('news_stocks'));
    }

    renderHeader() {
        return <h2 className="u-bold">{t('news_stocks')}</h2>;
    }
}

const mapStateToProps = (state) => {
    return {
        news: state.news,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({fetchNews}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NewsStocks);



// WEBPACK FOOTER //
// ./src/js/components/NewsStocks.js